import { useState } from "react";
import { Button, Loader } from "@mantine/core";

export function RefreshButton() {
	const [loading, setLoading] = useState(false);

	const handleClick = () => {
		setLoading(true);
		setTimeout(() => window.location.reload(), 100);
	};

	return (
		<Button
			mt="md"
			disabled={loading}
			rightSection={loading ? <Loader size="xs" /> : undefined}
			onClick={handleClick}
		>
			Refresh
		</Button>
	);
}
